
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { requiredBoolean } from './required-boolean.validator';

export function getSelfServiceProjectAsRequestedDtoFormGroup() {
return new FormGroup({
    desiredMontageAppointmentDate: new FormControl<string | undefined>(''),
    desiredDemontageAppointmentDate: new FormControl<string | undefined>(''),
    appointmentDateFound: new FormControl<boolean | undefined>(undefined, [requiredBoolean()]),
    appointmentNotWanted: new FormControl<boolean | undefined>(undefined, [requiredBoolean()]),
})
;
}
      